/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from 'react';
import { Form, Table, ConfigProvider,Space,Tag} from 'antd';
import { hnrequest } from '@/utils'
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const Bcz = () => {
  
  
   const [bangm, setbangm] = useState([]);
  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/p_paylist')
       setbangm(res.rescode)
    }
  
    getau()
  
  }, [])
  

 



 
 const columns = [
  
  {
    title: '订单编号',
    dataIndex: 'ddno',
    key: 'ddno',
  },
  {
    title: '金额',
    dataIndex: 'samount',
    key: 'samount',
  },
  {
    title: '支付方式',
    dataIndex: 'p_w',
    key: 'p_w',
      render: (_, record) => (
        <Space size="middle">
          {record.p_w === "支付宝" &&  <Tag color="blue" >支付宝</Tag> }
          {record.p_w === "微信" && <Tag color="#87d068" >微信</Tag>}
          {record.p_w === "系统调账" && <Tag color="volcano" >系统调账</Tag>}
        </Space>
      ),
  },
  {
    title: '支付时间',
    dataIndex: 'pay_time',
    key: 'pay_time',
  }
];
  

  

 









  const [form] = Form.useForm();
  return (<ConfigProvider locale={zhCN} >

    <div 
    // style={containerStyle} 
    >

      <Form form={form} component={false}>

      <Table size='small' columns={columns} dataSource={bangm} rowKey="ddno"/>

      </Form>


      
    </div>

    
  </ConfigProvider>

  );
};
export default Bcz;